import { render, staticRenderFns } from "./ServiceEntitySingle.vue?vue&type=template&id=3aa9b79a&"
import script from "./ServiceEntitySingle.vue?vue&type=script&lang=js&"
export * from "./ServiceEntitySingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports